/** Board zoom steps (1 = 100%). */
export const PLANNING_ZOOM_LEVELS = [0.6, 0.7, 0.8, 0.9, 1, 1.15, 1.3, 1.5] as const;

const STORAGE_KEY = 'planning.zoom';

/** The next zoom step in `direction` from `current`, clamped to the ends. */
export function stepZoom(current: number, direction: 1 | -1): number {
  const levels: readonly number[] = PLANNING_ZOOM_LEVELS;
  if (direction === 1) return levels.find((z) => z > current + 1e-6) ?? levels[levels.length - 1];
  return [...levels].reverse().find((z) => z < current - 1e-6) ?? levels[0];
}

/** Zoom is per device (a laptop and a big screen want different zoom), so it lives
 *  in localStorage, not in the server-side planning preferences. */
export function loadZoom(): number {
  try {
    const z = Number(window.localStorage.getItem(STORAGE_KEY));
    return (PLANNING_ZOOM_LEVELS as readonly number[]).includes(z) ? z : 1;
  } catch {
    return 1;
  }
}

export function saveZoom(zoom: number): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(zoom));
  } catch {
    // Storage blocked (private mode, site data off) — zoom stays session-only.
  }
}
